import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '@lili/lili-frontend-common';
import { AccessLevel, RoleType } from '../../../../../types';
import { ReactComponent as QuestionMarkIcon } from '../../../../../assets/icons/svg/shared/ic-shared-question-mark.svg';

interface RoleItemRolePermissionsProps {
  permission: AccessLevel;
  role: RoleType;
  onInfoClick: (role: RoleType) => void;
}

export const RoleItemRolePermissions = ({ permission, onInfoClick, role }: RoleItemRolePermissionsProps) => {
  const { t } = useTranslation();
  const accessTitle = (() => {
    switch (permission) {
      case AccessLevel.FULL_ACCESS:
        return t('ACCOUNT_SETTINGS.TEAM.TABLE.PERMISSION_TYPE.FULL');
      case AccessLevel.LIMITED_ACCESS:
        return t('ACCOUNT_SETTINGS.TEAM.TABLE.PERMISSION_TYPE.LIMITED');
      default:
        return '';
    }
  })();
  return (
    <div className='flex flex-col '>
      <div className='flex flex-row gap-[4px] items-center'>
        <Heading.H10 className='text-text-main-primary '>{accessTitle}</Heading.H10>
        {permission !== AccessLevel.FULL_ACCESS && (
          <button
            type='button'
            onClick={() => onInfoClick(role)}
            className='hover:bg-surface-primary-bw-02 h-[24px] w-[24px] rounded-[50%] flex items-center justify-center'
          >
            <QuestionMarkIcon onClick={() => onInfoClick(role)} className='h-[16px] w-[16px] text-text-main-primary' />
          </button>
        )}
      </div>
    </div>
  );
};
